import {
  ArrowUpRightIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { Button } from "components/Graphs/Button";
import { useFeatureFlagPayload } from "posthog-js/react";
import React, { useEffect, useState } from "react";

interface InfoBannerPayload {
  enabled: boolean;
  bannerConfig: BannerConfig;
}

interface BannerConfig {
  message: string;
  containerDiv: string;
  textDiv: string;
}

export const InfoBanner: React.FC<{ className?: string }> = ({ className }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [bannerConfig, setBannerConfig] = useState<BannerConfig | null>(null);

  // Get the feature flag payload from PostHog
  const flagPayload = useFeatureFlagPayload("info-banner");

  useEffect(() => {
    const flagPayloadObj = flagPayload as unknown as InfoBannerPayload;
    if (flagPayloadObj && typeof flagPayloadObj === "object") {
      // Check if banner is enabled
      if (flagPayloadObj.enabled) {
        setBannerConfig(flagPayloadObj.bannerConfig);
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } else {
      setIsVisible(false);
    }
  }, [flagPayload]);

  if (!isVisible || !bannerConfig) {
    return null;
  }

  return (
    <div
      className={`w-full max-w-7xl mx-auto sm:px-6 lg:px-8 py-2 ${className}`}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div
          className={`flex flex-row items-center justify-start border rounded-lg p-2 ${bannerConfig?.containerDiv}`}
        >
          <div className="flex flex-row items-center w-full">
            <div className="flex flex-row justify-center w-full">
              <div
                className={`flex flex-row items-center gap-1 text-sm justify-center ${bannerConfig?.textDiv}`}
              >
                {bannerConfig?.message}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoBanner;
